"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _kitten_list = require("@/api/kitten_list");

var _kitten_sort = require("@/api/kitten_sort");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      catList: null,
      listLoading: true,
      activeName: 'first',
      catIdList: []
    };
  },
  components: {
    vuedraggable: _vuedraggable.default
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      (0, _kitten_list.getKittenList)().then(function (response) {
        var catList = response.data;
        var _catList = [];
        (0, _kitten_sort.getKittenSortList)().then(function (kittenSortList) {
          // 第一次排序，数据库中排序记录为空，所以直接按照默认排序展示
          if (!kittenSortList.data) {
            _this.catList = catList;
            return;
          } else {
            var sortList = kittenSortList.data.list;
            sortList.split(',').forEach(function (id) {
              catList.forEach(function (cat, catI) {
                if (cat.id == id) {
                  _catList.push(cat);

                  catList.splice(catI, 1);
                }
              });
            });

            if (catList.length > 0) {
              _this.catList = _catList.concat(catList);
            } else {
              _this.catList = _catList;
            }
          }
        });
      });
    },
    // 拖拽动作完成后，获取最新列表并保存
    end: function end() {
      var _this2 = this;

      var $ = this;
      $.catIdList = [];
      $.catList.forEach(function (cat, catI) {
        $.catIdList.push(cat.id);
      });
      $.$store.dispatch('kitten_sort/edit', {
        kitten_sort_list: $.catIdList
      }).then(function (data) {
        console.log(data);

        _this2.$message({
          message: data.msg,
          type: 'success'
        });

        _this2.editCatTagsForm.tags.push(data.data);

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};
exports.default = _default;